import { render, staticRenderFns } from "./Customerservice.vue?vue&type=template&id=279a8c76&scoped=true"
import script from "./Customerservice.vue?vue&type=script&lang=js"
export * from "./Customerservice.vue?vue&type=script&lang=js"
import style0 from "./Customerservice.vue?vue&type=style&index=0&id=279a8c76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279a8c76",
  null
  
)

export default component.exports